export const dayPickerInputPortalContentClassName: string = 'day-picker-input-portal-content';
